import RandomOrder from './randomOrder';

export default (di) => {
	di
		.setType({type: RandomOrder, name: 'RandomOrder', parent: 'PageComponent'})
	;
};
